import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { mainListItems, secondaryListItems } from '../listItems';
import { Link, useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

import {
  TextField, Button, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, TablePagination
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme();


export default function ECustomer() {

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));

  if (user) {
    const role = user.role;
    console.log('Role:', role);
  } else {
    console.log('No user data found in session storage');
  }



  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [civil_id, setCivil_id] = useState('');
  const [nationality, setNationality] = useState('');
  const [mobile, setMobile] = useState('');
  const [whatsapp_no, setWhatsapp_no] = useState('');
  const [telephone_no, setTelephone_no] = useState('');
  const [address, setAddress] = useState('');
  const [paci_number, setPaci_number] = useState('');
  const [customers, setCustomer] = useState([]);
  const [searchCustomer, setSearchCustomer] = useState([]);
  const [searchCivilID, setSearchCivilID] = useState('');
  const [errors, setErrors] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Search filters state
  const [searchCustomerName, setSearchCustomerName] = useState('');
  const [searchCustomerEmail, setSearchCustomerEmail] = useState('');
  const [searchCustomerAddress, setSearchCustomerAddress] = useState('');
  const [searchCustomerNationality, setSearchCustomerNationality] = useState('');
  const [searchCustomerCivilId, setSearchCustomerCivilId] = useState('');
  const [searchCustomerPaciNumber, setSearchCustomerPaciNumber] = useState('');

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://app.smartco.live/api/customer/${id}`);
      await axios.delete(`https://app.smartco.live/api/users/${id}`);
      alert("Customer record deleted successfully");
      fetchCustomers();// Refresh the customer list after deletion
    } catch (error) {
      console.error('Error deleting Customer:', error);
      alert("An error occurred while deleting the selling record.");
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const handleLogout = () => {
    // Remove user details from session storage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    console.log('User details cleared from session storage');
    navigate('/');
  };

  const resetTable = () => {

    fetch('https://app.smartco.live/api/customer/', {
      method: 'GET'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setSearchCustomer(data))
      .catch(error => {
        console.error('Error fetching data:', error);
        // Handle error accordingly
      });
  };

  const validate = () => {
    const errors = [];

    if (!/^[a-zA-Z\s]+$/.test(name)) {
      errors.push("Name should not contain numbers or special characters.");
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.push("Enter a valid email address.");
    }

    if (/[^a-zA-Z0-9]/.test(civil_id)) {
      errors.push("Civil ID should not contain special characters.");
    }

    setErrors(errors.length ? {
      name: errors.includes("Name should not contain numbers or special characters.") ? "Name should not contain numbers or special characters." : "",
      email: errors.includes("Enter a valid email address.") ? "Enter a valid email address." : "",
      civil_id: errors.includes("Civil ID should not contain special characters.") ? "Civil ID should not contain special characters." : ""
    } : {});
    return errors;
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://app.smartco.live/api/customer/');
      setCustomer(response.data);
      setSearchCustomer(response.data);
    } catch (error) {
      console.error('Error fetching payments:', error);
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validate();
    if (errors.length > 0) {
      alert("Please correct the following errors:\n\n" + errors.join("\n"));
      return;
    }

    const NewCustomer = {
      name,
      email,
      password,
      civil_id,
      nationality,
      mobile,
      whatsapp_no,
      telephone_no,
      address,
      paci_number
    };

    const NewUser = {
      name,
      email,
      password,
      role: "customer"
    }

    try {
      await axios.post('https://app.smartco.live/api/customer/register', NewCustomer);
      await axios.post('https://app.smartco.live/api/users/register', NewUser);
      alert("New Customer added successfully");
      fetchCustomers();
    } catch (error) {
      console.error('Error adding customer:', error);
      alert(`Error adding customer: ${error.response ? error.response.data.message : error.message}`);
    }
  };

  const fetchCustomerDetails = (event) => {
    if (event) {
      event.preventDefault(); // Prevent default form submission
    }
    let filteredData = customers.filter(items => {
      return (searchCivilID === '' || items.civil_id === (searchCivilID));
    });
    setSearchCustomer(filteredData);
    setSearchCivilID('');
  };

  const [open, setOpen] = useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Comprehensive search/filter function for customers
  const handleSearchCustomers = () => {
    let filtered = [...customers];

    // Filter by Name
    if (searchCustomerName.trim()) {
      filtered = filtered.filter((customer) =>
        customer.name && customer.name.toLowerCase().includes(searchCustomerName.toLowerCase())
      );
    }

    // Filter by Email
    if (searchCustomerEmail.trim()) {
      filtered = filtered.filter((customer) =>
        customer.email && customer.email.toLowerCase().includes(searchCustomerEmail.toLowerCase())
      );
    }

    // Filter by Address
    if (searchCustomerAddress.trim()) {
      filtered = filtered.filter((customer) =>
        customer.address && customer.address.toLowerCase().includes(searchCustomerAddress.toLowerCase())
      );
    }

    // Filter by Nationality
    if (searchCustomerNationality.trim()) {
      filtered = filtered.filter((customer) =>
        customer.nationality && customer.nationality.toLowerCase().includes(searchCustomerNationality.toLowerCase())
      );
    }

    // Filter by Civil ID
    if (searchCustomerCivilId.trim()) {
      filtered = filtered.filter((customer) =>
        customer.civil_id && customer.civil_id.includes(searchCustomerCivilId)
      );
    }

    // Filter by Paci Number
    if (searchCustomerPaciNumber.trim()) {
      filtered = filtered.filter((customer) =>
        customer.paci_number && customer.paci_number.includes(searchCustomerPaciNumber)
      );
    }

    setSearchCustomer(filtered);
    setPage(0); // Reset to first page when searching
  };

  // Reset function for customer search
  const handleResetCustomerSearch = () => {
    setSearchCustomerName('');
    setSearchCustomerEmail('');
    setSearchCustomerAddress('');
    setSearchCustomerNationality('');
    setSearchCustomerCivilId('');
    setSearchCustomerPaciNumber('');
    setSearchCustomer(customers); // Reset to show all customers
    setPage(0);
  };

  return (
    <div>
      <ThemeProvider theme={mdTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar sx={{ backgroundColor: 'white', color: '#637381' }} position="absolute" open={open}>
            <Toolbar
              sx={{
                pr: '24px', // keep right padding when drawer closed
              }}
            >
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                sx={{
                  marginRight: '36px',
                  ...(open && { display: 'none' }),
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                component="h1"
                variant="h6"
                noWrap
                sx={{
                  flexGrow: 1,
                  background: 'linear-gradient(90deg, #C63DE7, #752888)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontFamily: 'Public Sans, sans-serif',
                  fontWeight: 'bold',
                }}
              >
                SMARTCO
              </Typography>
              <IconButton color="inherit" onClick={handleLogout}>
                <Badge color="secondary">
                  <LogoutIcon />
                </Badge>
              </IconButton>
            </Toolbar>
          </AppBar>
          <Drawer variant="permanent" open={open}>
            <Toolbar
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: [1],
              }}
            >
              <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon />
              </IconButton>
            </Toolbar>
            <Divider />
            <List component="nav">
              {mainListItems}
              <Divider sx={{ my: 1 }} />
              {secondaryListItems}
            </List>
          </Drawer>
          <Box
            component="main"
            sx={{
              backgroundColor: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[100]
                  : theme.palette.grey[900],
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            }}
          >
            <Toolbar />
            <Container>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop: 4,
                  padding: 3,
                  backgroundColor: '#fff',
                  borderRadius: 1,
                  boxShadow: 3,
                  maxWidth: 500, // Adjust the maxWidth as needed
                  width: '100%',
                  mx: 'auto', // Center the box
                }}
              >
                <Typography component="h1" variant="h5" gutterBottom sx={{ fontFamily: 'Public Sans, sans-serif', fontWeight: 'bold', color: "#637381" }}>
                  Customer Details
                </Typography>
                <Box component="form" sx={{ mt: 1 }} onSubmit={handleSubmit}>
                  <TextField margin="normal" required fullWidth label="User Name" onChange={(e) => setName(e.target.value)} error={!!errors.email} helperText={errors.email} />
                  <TextField margin="normal" required fullWidth label="E-mail" onChange={(e) => setEmail(e.target.value)} error={!!errors.name} helperText={errors.name} />
                  <TextField margin="normal" required fullWidth label="Mobile Number" onChange={(e) => setMobile(e.target.value)} />
                  <TextField margin="normal" required fullWidth label="WhatsApp Number" onChange={(e) => setWhatsapp_no(e.target.value)} />
                  <TextField margin="normal" required fullWidth label="Telephone Number" onChange={(e) => setTelephone_no(e.target.value)} />
                  <TextField margin="normal" required fullWidth label="Address" onChange={(e) => setAddress(e.target.value)} />
                  <TextField margin="normal" required fullWidth label="Nationality" onChange={(e) => setNationality(e.target.value)} />
                  <TextField margin="normal" required fullWidth label="Civil ID" onChange={(e) => setCivil_id(e.target.value)} error={!!errors.email} helperText={errors.email} />
                  <TextField margin="normal" required fullWidth label="Paci Number" onChange={(e) => setPaci_number(e.target.value)} />
                  <TextField margin="normal" required fullWidth label="Password" type="password" onChange={(e) => setPassword(e.target.value)} />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 2,
                      backgroundColor: '#752888',
                      '&:hover': {
                        backgroundColor: '#C63DE7',
                      },
                      fontFamily: 'Public Sans, sans-serif',
                      fontWeight: 'bold',
                    }}
                  >
                    Register
                  </Button>
                </Box>
              </Box>

              <Box
                sx={{
                  marginTop: 4,
                  padding: 3,
                  backgroundColor: "#fff",
                  borderRadius: 1,
                  boxShadow: 3,
                  maxWidth: 1200,
                  width: "100%",
                  mx: "auto",
                }}
              >
                <Typography
                  component="h1"
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontFamily: "Public Sans, sans-serif",
                    fontWeight: "bold",
                    color: "#637381",
                  }}
                >
                  Search Customer Records
                </Typography>
                <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                  <TextField
                    label="User Name"
                    value={searchCustomerName}
                    onChange={(e) => setSearchCustomerName(e.target.value)}
                    fullWidth
                  />
                  <TextField
                    label="E-mail"
                    value={searchCustomerEmail}
                    onChange={(e) => setSearchCustomerEmail(e.target.value)}
                    fullWidth
                  />
                  <TextField
                    label="Address"
                    value={searchCustomerAddress}
                    onChange={(e) => setSearchCustomerAddress(e.target.value)}
                    fullWidth
                  />
                  <TextField
                    label="Nationality"
                    value={searchCustomerNationality}
                    onChange={(e) => setSearchCustomerNationality(e.target.value)}
                    fullWidth
                  />
                  <TextField
                    label="Civil ID"
                    value={searchCustomerCivilId}
                    onChange={(e) => setSearchCustomerCivilId(e.target.value)}
                    fullWidth
                  />
                  <TextField
                    label="Paci Number"
                    value={searchCustomerPaciNumber}
                    onChange={(e) => setSearchCustomerPaciNumber(e.target.value)}
                    fullWidth
                  />
                </Box>
                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                  <Button
                    variant="contained"
                    onClick={handleSearchCustomers}
                    sx={{
                      backgroundColor: "#752888",
                      "&:hover": {
                        backgroundColor: "#C63DE7",
                      },
                      fontFamily: "Public Sans, sans-serif",
                      fontWeight: "bold",
                    }}
                  >
                    Fetch Data
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleResetCustomerSearch}
                    sx={{
                      backgroundColor: "#637381",
                      "&:hover": {
                        backgroundColor: "#7f8c8d",
                      },
                      fontFamily: "Public Sans, sans-serif",
                      fontWeight: "bold",
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Box>


              {/* Table Section */}
              <Box sx={{
                mt: 6,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: 4,
                padding: 3,
                backgroundColor: '#fff',
                borderRadius: 1,
                boxShadow: 3,
                maxWidth: 1500, // Adjust this value as needed
                flexGrow: 1,
                mx: 'auto',
              }}>
                <TableContainer component={Paper}>
                  <Table >
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >User Name</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >E-mail</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Mobile</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Whatsapp Number</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Telephone Number</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Address</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Nationality</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Civil ID</TableCell>
                        <TableCell style={{ backgroundColor: '#752888', color: 'white' }} >Paci Number</TableCell>
                        {user?.role !== "employee" && (
                          <TableCell style={{ backgroundColor: '#752888', color: 'white' }}>
                            Action
                          </TableCell>
                        )}

                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {searchCustomer.length > 0 && searchCustomer
                        .slice()
                        .reverse()
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((customer) => (
                          <TableRow key={customer._id}>
                            <TableCell>{customer.name}</TableCell>
                            <TableCell>{customer.email}</TableCell>
                            <TableCell>{customer.mobile}</TableCell>
                            <TableCell>{customer.whatsapp_no}</TableCell>
                            <TableCell>{customer.telephone_no}</TableCell>
                            <TableCell>{customer.address}</TableCell>
                            <TableCell>{customer.nationality}</TableCell>
                            <TableCell>{customer.civil_id}</TableCell>
                            <TableCell>{customer.paci_number}</TableCell>
                            <TableCell>
                              <Link to={`eupdatecustomer/${customer.email}`}>
                                {user?.role !== "employee" && (
                                  <IconButton color="primary">
                                    <EditIcon />
                                  </IconButton>
                                )}
                              </Link>
                              {user?.role !== "employee" && (
                                <IconButton
                                  color="secondary"
                                  onClick={() => handleDelete(customer.email)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              )}

                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2,
                    pb: 2,
                    borderTop: '1px solid #e0e0e0',
                    backgroundColor: '#fafafa',
                  }}
                >
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={searchCustomer.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                      width: '100%',
                      '& .MuiTablePagination-toolbar': {
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        padding: { xs: '8px', sm: '16px' },
                      },
                      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                        fontFamily: 'Public Sans, sans-serif',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        color: '#637381',
                        fontWeight: 500,
                      },
                      '& .MuiTablePagination-select': {
                        fontFamily: 'Public Sans, sans-serif',
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        padding: '4px 8px',
                        border: '1px solid #e0e0e0',
                        '&:hover': {
                          backgroundColor: '#f5f5f5',
                        },
                      },
                      '& .MuiTablePagination-actions': {
                        marginLeft: { xs: '8px', sm: '20px' },
                        '& .MuiIconButton-root': {
                          backgroundColor: '#fff',
                          border: '1px solid #e0e0e0',
                          borderRadius: '8px',
                          padding: '8px',
                          margin: '0 4px',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            backgroundColor: '#752888',
                            borderColor: '#752888',
                            color: '#fff',
                          },
                          '&.Mui-disabled': {
                            backgroundColor: '#f5f5f5',
                            borderColor: '#e0e0e0',
                            opacity: 0.5,
                          },
                        },
                      },
                    }}
                  />
                </Box>
              </Box>
            </Container>
          </Box>
        </Box>
      </ThemeProvider>
    </div>
  );
}
